import styles from './PageLoader.module.css';

export function PageLoader() {
  return (
    <div className={styles.loader} role="status" aria-live="polite" aria-busy="true">
      <div className={styles.spinner} aria-hidden="true" />
      <span className={styles.srOnly}>Loading…</span>
    </div>
  );
}
